import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { ObjectSharing, ObjectSharingParam } from '../object-sharing.model';

export enum GroupSharingActionTypes {
  GetGroupSharingList = '[GroupSharing] Get GroupSharingList',
  LoadGroupSharingList = '[GroupSharing] Load GroupSharingList',
  AddGroupSharing = '[GroupSharing] Add GroupSharing',
  UpdateGroupSharing = '[GroupSharing] Update GroupSharing',
  DeleteGroupSharing = '[GroupSharing] Delete GroupSharing',
  GetGroupSharingListFail = '[GroupSharing] Get GroupSharingList Fail'
}

export class GetGroupSharingList implements Action {
  readonly type = GroupSharingActionTypes.GetGroupSharingList;
  constructor(public payload: any = null) {}
}

export class LoadGroupSharingList implements Action {
  readonly type = GroupSharingActionTypes.LoadGroupSharingList;

  constructor(public payload: ObjectSharing[]) {}
}

export class AddGroupSharing implements Action {
  readonly type = GroupSharingActionTypes.AddGroupSharing;

  constructor(public payload: ObjectSharingParam) {}
}

export class UpdateGroupSharing implements Action {
  readonly type = GroupSharingActionTypes.UpdateGroupSharing;

  constructor(public payload: ObjectSharingParam) {}
}

export class DeleteGroupSharing implements Action {
  readonly type = GroupSharingActionTypes.DeleteGroupSharing;

  constructor(public payload: ObjectSharingParam) {}
}

export class GetGroupSharingListFail implements Action {
  readonly type = GroupSharingActionTypes.GetGroupSharingListFail;
}

export type GroupSharingActions =
 GetGroupSharingList
 | LoadGroupSharingList
 | AddGroupSharing
 | UpdateGroupSharing
 | DeleteGroupSharing
 | GetGroupSharingListFail;
